import { timeType } from "types";
import moment from "moment";

export const vivatimes2times = (data) => {
  const times: timeType[] = [];
  const performances = data.DAYLIST.DAY.PERFORMANCELIST.PERFORMANCE;

  if (Array.isArray(performances)) {
    data.DAYLIST.DAY.PERFORMANCELIST.PERFORMANCE.map((perf) => {
      let time: timeType = {
        perfID: perf.AK._text,
        time: perf.TIME._text,
        //text: perf.TIME._text,
        selected: "",
        text: moment(perf.TIME._text, "h:mm a").format("LT"),
        spotLeft: parseInt(perf.AVAILABILITY.AVAILABLE._text) || 0,
        available: (parseInt(perf.AVAILABILITY.AVAILABLE._text) || 0) > 0 ? true : false,
      };
      times.push(time);
    });
  } else {
    let time: timeType = {
      perfID: performances.AK._text,
      time: performances.TIME._text,
      //text: perf.TIME._text,
      selected: "",
      text: moment(performances.TIME._text, "h:mm a").format("LT"),
      spotLeft: parseInt(performances.AVAILABILITY.AVAILABLE._text) || 0,
      available: (parseInt(performances.AVAILABILITY.AVAILABLE._text) || 0) > 0 ? true : false,
    };
    times.push(time);
  }
  return times;
};
